export default "__VITE_ASSET__CNtD_qfX__"